export default __webpack_public_path__ + "static/media/airvendlogo 1.b0b84a26.svg";